import React, { useEffect, useState } from 'react'
import Services from '../service/Services'
import axios from 'axios'
import Spinner from '../components/Spinner'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { format } from 'date-fns';
import 'react-datetime/css/react-datetime.css';
import { useAlert } from "react-alert";
import { HiCheck } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import NoteCreatedList from '../components/NoteCreatedList';

let curentDate = format(new Date(), 'yyyy-MM-dd');

export default function Createnote() {
  const alert = useAlert();
  const navigation = useNavigate()
  const [loading, setLoading] = useState(false)
  const [customer, setCustomer] = useState("")
  const [ServiceID, setServiceID] = useState("")
  const [ServiceName, setServiceName] = useState("")
  const [ServiceSACCode, setServiceSACCode] = useState("")
  const [purchaseorder, setPurchaseOrder] = useState("")
  const [podate, setPodate] = useState("")
  const [taxdata, setTax] = useState("")
  const [invoiceDate, setInvoiceDate] = useState(curentDate)
  // Error set 
  const [customererror, setCustomerError] = useState("")
  const [purchaseordererror, setPurchaseOrderError] = useState("")
  //const [podateerror, setPodateError ] =useState("")
  const [invoiceDateerror, setinvoiceDateError] = useState("")
  const [taxerror, setTaxError] = useState("")
  const [serviceerror, setServiceError] = useState("")
  const [profileError, setProfileError] = useState("")
  //const [profileData, setProfile] =useState([]);
  const [newProfile, setNewProfile] = useState([])
  const [PoObjectId, setPoObjectId] = useState("")

  // const [disabled, setDisabled] =useState(false)
  // Multi Checkbox
  const handleChanges = (index, e, value) => {
    //console.log('Input Val: ',value.profileName)
    const intialObject = poData.find((item, i) => item.profileName === value.profileName);
    const { checked } = e.target;
    if (checked) {
      //setDisabled(true)
      setNewProfile((old) => [...old, intialObject]);
    } else {
      setNewProfile((old) => [...old.filter((e, i) => e.profileName !== value.profileName)]
      );
    }
  };
  const handleRate = (index, e, value) => {
    const newArray = newProfile.map((item, i) => {
      if (item.profileName === value.profileName) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setNewProfile(newArray);
  }
  const handleRemark = (index, e, value) => {
    const newArray = newProfile.map((item, i) => {
      if (item.profileName === value.profileName) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setNewProfile(newArray);
  }
  const validation = () => {
    const errors = {}
    if (customer === '') {
      errors.customer = 'Select the customer'
    } if (purchaseorder === '') {
      errors.purchaseorder = 'Enter the purchase order'
    } if (invoiceDate === '') {
      errors.invoiceDate = 'Select the Date'
    }
    if (taxdata === '') {
      errors.taxdata = 'Enter the tax'
    }
    if (newProfile.length === 0) {
      errors.newProfile = 'Select the Profile at leat one!'
    }
    return Object.keys(errors).length === 0 ? null : errors;
  }
  const handlesubmit = (e) => {
    e.preventDefault();
    const errors = validation();
    if (errors) {
      setCustomerError(errors.customer);
      setPurchaseOrderError(errors.purchaseorder);
      //setPodateError(errors.podate);
      setinvoiceDateError(errors.invoiceDate);
      setTaxError(errors.taxdata);
      setServiceError(errors.serviceType);
      setProfileError(errors.newProfile);
    } else {
      var notelistData = newProfile;
      //console.log(notelistData)
      var fNameData = ServiceName;
      var SACCodeData = ServiceSACCode;
      var fIDData = ServiceID;
      setLoading(true)
      Services.noteCreate.create(customer, PoObjectId, fIDData, fNameData, SACCodeData, notelistData, taxdata, purchaseorder, invoiceDate).then(function (result) {
        if (result.success === true) {
          setLoading(false)
          alert.success(result.message);
          navigation("/");
        }
      });
    }
  }
  const [customerlist, setCustomerList] = useState([]);
  const [invoicelist, setInvoiceList] = useState([]);
  const [invoiceDetail, setInvoiceDetail] = useState(null);
  const getCustomerlist = async () => {
    try {
      const response = await axios.get("/v1/api/customer", { headers: { "authorization": `Bearer ${localStorage.getItem('token')}` } });
      if (response.data.success === true) {
        setCustomerList(response.data.data);
      } else {
        setCustomerList([]);
      }
    } catch (error) {
      console.log(error);
      // setProfile({data:[]});
    }
  };

  useEffect(() => {
    getCustomerlist();
  }, []);

  const getInvoicelist = async (e) => {
    try {
      setCustomer(e)
      const response = await axios.get("/v1/api/getInvoiceByCustomer/" + e, { headers: { "authorization": `Bearer ${localStorage.getItem('token')}` } });
      if (response.data.success === true) {
        setInvoiceList(response.data.data);
      } else {
        setInvoiceList([]);
      }
    } catch (error) {
      console.log(error);
      setInvoiceList([]);
      // setProfile({data:[]});
    }
  };
  const [poData, setPoData] = useState([]);
  const getInvoiceDetails = async (e) => {
    try {
      const response = await axios.get("/v1/api/getInvoiceByid/" + e, { headers: { "authorization": `Bearer ${localStorage.getItem('token')}` } });
      if (response.data) {
        setPoObjectId(e);
        setInvoiceDetail(response.data);
        setTax(response.data.tax);
        setPodate(response.data.podate || '');
        // Extract all service IDs from the populated service array
        const serviceIds = response.data.service && Array.isArray(response.data.service) 
          ? response.data.service.map(s => s._id || s) 
          : (response.data.service?.[0]?._id ? [response.data.service[0]._id] : []);
        setServiceID(serviceIds.length > 0 ? serviceIds[0] : '');
        setServiceName(response.data.service_name || []);
        setServiceSACCode(response.data.service_code || '');
        setPurchaseOrder(response.data.po || '')
        setPoData(response.data.profileName_rate || [])
      } else {
        //alert.error('Sorry Invoice Not Available!');
      }
    } catch (error) {
      console.log(error);
      setInvoiceDetail(null);
      setTax('');
      setPodate('');
      setServiceID('');
      setServiceName('');
      setServiceSACCode('');
      setPurchaseOrder('');
      setPoData([]);
      //setProfile({data:[]});
    }
  };

  //console.log(poData)
  // useEffect(() => {  
  //   getPODetails();
  // },[])
  //console.log(posDetail[0]?.servicename)
  // console.log(customerlist)

  function getDueDateLabel(reminderDateStr) {
    if (!reminderDateStr) return '';

    try {
      const today = new Date();
      const reminderDate = new Date(reminderDateStr);
      const diffTime = reminderDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (!isNaN(diffDays)) {
        if (diffDays > 0) {
          return `Due in ${diffDays} day${diffDays !== 1 ? 's' : ''}`;
        } else if (diffDays === 0) {
          return 'Due today';
        } else {
          return `Overdue by ${Math.abs(diffDays)} day${Math.abs(diffDays) !== 1 ? 's' : ''}`;
        }
      }
    } catch (e) {
      console.error('Invalid reminder date', e);
    }
    return '';
  }

  return (
    <div className="flex flex-col gap-4 w-full">
      <ToastContainer />
      {loading && <Spinner />}
      <div className='card p-3'>
        <h1 className='text-lg'> Affiliate (Credit Note)</h1>
        <hr />
        <form onSubmit={handlesubmit}>
          <div className="grid gap-6 mb-6 md:grid-cols-3 mt-6">
            <div>
              <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Customer</label>
              <select onChange={(e) => { getInvoicelist(e.target.value) }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[20rem] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <option>Choose your customer..</option>
                {customerlist.map(customer => (
                  <option key={customer._id} value={customer._id}>{customer.name}</option>
                ))}
              </select>
              <div className='text-red-500 text-sm'>{customererror}</div>
            </div>
            <div>
              <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Invoice</label>
              <select onChange={(e) => { getInvoiceDetails(e.target.value) }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[20rem] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <option>Choose your Invoice..</option>
                {(invoicelist.length !== 0) ?
                  invoicelist?.map(invoice => (
                    <option key={invoice._id} value={invoice._id}>{invoice.invoice}</option>
                  )) : ''}
              </select>
              <div className='text-red-500 text-sm'>{purchaseordererror}</div>
            </div>
            <div>
              <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Invoice Date</label>
              <input type="date"
                //max={moment().format("YYYY-MM-DD")}
                value={invoiceDate}
                //value={podate}
                //onChange={(e)=>{setPodate(e.target.value)}} 
                onChange={(e) => { setInvoiceDate(e.target.value) }}
                id="last_name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[14rem] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              <div className='text-red-500 text-sm ml-24'>{invoiceDateerror}</div>
            </div>
            <div>
              <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Selected Tax</label>
              <label className="inline-flex items-center">
                {(invoiceDetail?.tax > 0) ?
                  <input type="hidden"
                    onChange={(e) => { setTax(e.target.value) }}
                    value={taxdata}
                    className="form-radio" name="accountType" checked />
                  : ''}
                {(invoiceDetail?.tax > 0) ? <span className="ml-1 mr-2"><HiCheck /></span> : ''}
                {(invoiceDetail?.tax > 0) ? <span className="ml-2 mr-3">{(invoiceDetail?.tax === 1) ? '18' : '18'}% {(invoiceDetail?.tax === 1) ? '(IGST)' : '(SGST 9% + CGST 9%)'}</span>
                  : ''}
              </label>
              <div className='text-red-500 text-sm'>{taxerror}</div>
            </div>
            <div className='w-[40rem]'>
              <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Service Details</label>
              {(invoiceDetail?.service_name && invoiceDetail.service_name.length !== 0) ?
                invoiceDetail.service_name.map((service, index) => (
                  <label key={index} className="inline-flex items-center">
                    <input type="hidden" name="serviceName"
                      //onChange={(e) => getServicesValues(e)}
                      // onChange={handleChange}
                      //value={service._id+','+service.sr_name+','+service.sac_code}
                      className="form-checkbox" checked />
                    <span className="ml-1 mr-2"><HiCheck /></span>
                    <span className="ml-1 mr-2">{service}</span>
                  </label>
                ))
                : ''}
              <div className='text-red-500 text-sm'>{serviceerror}</div>
            </div>
            <div></div>
            <div className="flex w-[60rem] mb-6 md:grid-cols-3 mt-6">
              <div>
                <p style={{ color: 'red', fontStyle: 'italic' }}>First click on the checkbox then change the amount & remark.**</p>
                <div className="flex">
                  <div className='w-[21rem]'>
                    <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select PO Details</label>
                  </div>
                  <div className='w-[21rem]'>
                    <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">PO Rate</label>
                  </div>
                  <div>
                    <label for="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">PO Remark</label>
                  </div>
                </div>
                {(poData.length !== 0) ?
                  poData.map((value, index) => {
                  console.log( getDueDateLabel(value.reminderDate)); 

                    return (
                      <div className="flex items-center mb-2 flex-wrap" key={index}>
                        {/* Profile Name & Invoice badge */}
                        <div className='w-[21rem] flex items-center'>
                          <input
                            type="checkbox"
                            id={`ProfileName-${index}`}
                            name="ProfileName"
                            value={value.profileName || ''}
                            onChange={e => handleChanges(index, e, value)}
                            // disabled={value.invoiceCreated === true}
                            className="form-checkbox"
                          />

                          <span className={`ml-2 mr-2 ${value.invoiceCreated ? 'text-gray-400' : 'text-black dark:text-white'}`}>
                            {value.profileName}
                          </span>

                          {value.invoiceCreated && (
                            <span className="ml-2 inline-flex items-center text-xs font-medium px-2 py-0.5 rounded 
                          bg-red-100 text-red-600 dark:bg-red-200 dark:text-red-800">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 12H6" />
                              </svg>
                              Invoice created
                            </span>
                          )}
                          <div className='text-red-500 text-xs ml-2'>{profileError}</div>
                        </div>

                        {/* PO Rate */}
                        <div className='w-[10rem] ml-2'>
                          <input
                            type="number"
                            id={`rate-${index}`}
                            name="rate"
                            defaultValue={value.rate || ''}
                            onChange={e => handleRate(index, e, value)}
                            // disabled={value.invoiceCreated === true}
                            className={`bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg 
                      focus:ring-blue-500 focus:border-blue-500 block w-full p-2 
                      dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
                      dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 
                      ${value.invoiceCreated ? 'opacity-60 cursor-not-allowed' : ''}`}
                            placeholder="PO Rate"
                          />
                        </div>

                        {/* PO Remark */}
                        <div className='w-[16rem] ml-2'>
                          <input
                            type="text"
                            id={`remark-${index}`}
                            name="remark"
                            onChange={e => handleRemark(index, e, value)}
                           // disabled={value.invoiceCreated === true}
                            className={`bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg 
                      focus:ring-blue-500 focus:border-blue-500 block w-full p-2 
                      dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
                      dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500
                      ${value.invoiceCreated ? 'opacity-60 cursor-not-allowed' : ''}`}
                            placeholder="PO Remark"
                          />
                        </div>

                        {/* Reminder info */}
                        {value.reminderRequired === 'Yes' && !value.invoiceCreated && (
                          <div className="ml-3 flex items-center">
                            {value.reminderSuccessful === true ? (
                              <span className="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded 
                            bg-green-100 text-green-700 dark:bg-green-200 dark:text-green-800">
                                ✅ Reminded on {value.reminderDate}
                              </span>
                            ) : (
                              <>
                                <span className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded 
                              ${value.invoiceCreated ? 'bg-gray-200 text-gray-500 dark:bg-gray-600 dark:text-gray-400'
                                    : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-200 dark:text-yellow-800'}`}>
                                  ⏰ Reminder set
                                </span>
                                {value.reminderDate && (
                                  <>
                                    <span className="ml-2 text-gray-600 text-xs dark:text-gray-300">
                                      📅 {value.reminderDate}
                                    </span>
                                    {getDueDateLabel(value.reminderDate) && (
                                      <span className="ml-2 text-gray-500 text-xs dark:text-gray-400">
                                        🕒 {getDueDateLabel(value.reminderDate)}
                                      </span>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })





                  : ''}
              </div>

            </div>
          </div>
          <div className="button-section">
            <button type="submit"
              className="flex flex-nowrap text-white text-bg-color active:bg-purple-200 font-bold uppercase text-sm px-4 py-2.5 rounded w-[10rem] shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"> Credit Note</button>
          </div>
        </form>
      </div>
      <NoteCreatedList />
    </div>
  )
}
